import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSingleDetailsFieldStyles = () => {
  return StyleSheet.create({
    leftColumn: {
      paddingRight: tokens.spacing.SPACING_10
    },
    singleBlockDetailsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      flex: 1
    },
    detailsSingleBlockWrapper: {
      maxWidth: '100%',
      marginBottom: tokens.spacing.SPACING_12
    },
    detailsSingleBlock: {
      display: 'flex',
      flexDirection: 'column'
    },
    marginValue: {
      marginTop: tokens.spacing.SPACING_4
    },
    infoTag: {
      marginTop: tokens.spacing.SPACING_8
    }
  });
};